import ACTIONS from "../../constants/actions";

const initialState = {
	sports          : [],
	leagues         : [],
	events          : [],
	factors         : [],
	results         : [],
	fetching        : true,
	isAlreadyLoaded : false
};

export default function mainLive(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.MAIN_LIVE.RECEIVE_PROPS:
			const newState = {
				...action.data,
				fetching : false,
				isAlreadyLoaded : true,
			};

			return Object.assign({}, {...state, ...newState});
		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/live.js